import Typography from "@mui/material/Typography"

import TextLink from "../../../common/components/TextLink"
import AdminAuthTitle from "../components/AdminAuthTitle"
import AdminLoadingPaper from "../components/AdminLoadingPaper"

export default function AdminForgotPasswordEmailSent() {
  return (
    <AdminLoadingPaper>
      <AdminAuthTitle title="Check your email" />
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        If an account exists for that email, a password reset link has been
        sent.
      </Typography>
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        <TextLink to="/admin/log-in/" text="Return to login" />
      </Typography>
    </AdminLoadingPaper>
  )
}
